import { DatePickerInput } from '@mantine/dates';
import { IconCalendar, IconAlertTriangle } from '../../../icons';
import styles from './DateInput.module.css';

/**
 * Date field backed by Mantine DatePickerInput: value is chosen only from the calendar
 * (the control is a button, not a text input). Calendar icon on the right; width is
 * content-sized, not full row.
 *
 * By default the dropdown opens on decades (`defaultLevel="decade"`); pass
 * `defaultLevel="year"` or `"month"` to start deeper in the hierarchy.
 */
export const DateInput = ({
  label,
  description,
  error,
  required,
  value,
  onChange,
  onBlur,
  placeholder,
  valueFormat = 'YYYY-MM-DD',
  defaultLevel = 'decade',
  disabled,
  readOnly,
  clearable,
  minDate,
  maxDate,
  popoverProps,
  name,
  form,
  classNames,
  rightSection: rightSectionProp,
  ...rest
}) => {
  const calendarSection = (
    <span className={styles.calendarIcon} aria-hidden>
      <IconCalendar size={18} />
    </span>
  );

  const rightSection =
    rightSectionProp ??
    (error ? (
      <IconAlertTriangle size={18} stroke={1.5} className="input-error-icon" />
    ) : (
      calendarSection
    ));

  return (
    <DatePickerInput
      label={label}
      description={description}
      error={error}
      required={required}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      valueFormat={valueFormat}
      defaultLevel={defaultLevel}
      disabled={disabled}
      readOnly={readOnly}
      clearable={clearable}
      minDate={minDate}
      maxDate={maxDate}
      popoverProps={popoverProps}
      name={name}
      form={form}
      rightSection={rightSection}
      rightSectionPointerEvents="none"
      classNames={{
        ...classNames,
        root: [styles.root, classNames?.root].filter(Boolean).join(' '),
      }}
      {...rest}
    />
  );
};
